/**
 * Returns the value of a provided css property
 *
 * @param {HTMLElement} element
 * @param {string} customPropertyName
 * @returns {string}
 */
export const getCssProperty = (element, customPropertyName) => {
  return getComputedStyle(element).getPropertyValue(customPropertyName);
};

/**
 * This checks if an element is visible inside the viewport or not and
 * therefore returns a boolean
 *
 * @param {HTMLElement} element
 * @returns {boolean}
 */
export const isVisibleInViewport = (element) => {
  const box = element.getBoundingClientRect();
  return (
    box.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    box.right <= (window.innerWidth || document.documentElement.clientWidth) &&
    box.top >= 0 &&
    box.left >= 0
  );
};
